import { Injectable } from '@angular/core';
import { ReplaySubject, Subject, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { BannerMessage } from './banner-message';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class BannerService {
    public bannerQueue: BannerMessage[] = [];
    public bannerEvent = new ReplaySubject<BannerMessage>();
    public bannerCloseEvent = new Subject();
    private bannerHeightSubject: Subject<number> = new ReplaySubject<number>(1);

    constructor(
        private sessionStorage: SessionStorageService,
        private localStorage: LocalStorageService) {
    }

    private static createInstance<T>(ctor: new() => T) {
        return new ctor();
    }

    private static isInstanceOf<T>(t1: BannerMessage, t2: new(...args: any[]) => T) {
        return BannerService.createInstance(t1.messageComponent) instanceof t2;
    }

    private static getBannerMessageKey(bannerMessage: BannerMessage) {
        // Create key to store banner in local storage
        return 'BANNER ' + bannerMessage.messageComponent.name + ' ' + JSON.stringify(bannerMessage.data);
    }

    public openBanner(bannerMessage: BannerMessage, dueTime = 0) {
        timer(dueTime)
            .pipe(take(1))
            .subscribe(() => {
                if (bannerMessage) {
                    if (bannerMessage.oncePerSession) {
                        const bannerSessionStorageKey = BannerService.getBannerMessageKey(bannerMessage);
                        const wasOpenDuringSession = this.sessionStorage.get(bannerSessionStorageKey);
                        if (wasOpenDuringSession) {
                            return;
                        }
                        this.sessionStorage.set(bannerSessionStorageKey, Boolean(true).toString());
                    }
                    if (bannerMessage.oncePerBrowser) {
                        const bannerIndexedDbStorageKey = BannerService.getBannerMessageKey(bannerMessage);
                        const wasOpenInThisBrowserBefore = this.localStorage.get(bannerIndexedDbStorageKey);
                        if (wasOpenInThisBrowserBefore) {
                            return;
                        }
                        this.localStorage.set(bannerIndexedDbStorageKey, Boolean(true).toString());
                    }


                    this.bannerEvent.next(bannerMessage);
                }
            });
    }

    public closeBanner<T>(t: new(...args: any[]) => T) {
        const index = this.bannerQueue.findIndex((b) => {
            return BannerService.isInstanceOf(b, t);
        });
        if (index >= 0) {
            this.bannerQueue.splice(index, 1);
            this.bannerCloseEvent.next();
        }
    }

    public setBannerHeight(height: number) {
        this.bannerHeightSubject.next(height);
    }

    public getBannerHeightObservable() {
        return this.bannerHeightSubject.asObservable();
    }
}
